import React, {ReactNode} from "react";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import back from "../../assets/images/arrow-left.svg";
import cancel from "../../assets/images/close.svg";
import FirebaseService from "../../core/services/firebaseService/firebase.service";
import {history} from "../../core/utilities/history";
import {IStore} from "../../core/utilities/reducers";
import {router} from "../../core/utilities/router";
import FirebaseKey from "../FirebaseKey/FirebaseKey";
import "./MiscHeader.scss";

interface IProps {
  pathname: string;
}

const MiscHeader = (props: IProps) => {
  
  function renderTitle(): ReactNode {
    let key = '';
    switch (props.pathname) {
      case router.FAQ:
        key = FirebaseService.header_help_desk;
        break;
      case router.CONTACT:
        key = FirebaseService.header_contact_us;
        break;
    }
    return <FirebaseKey className="title" firebaseKey={key}/>;
  }
  
  function renderButtonBack(): ReactNode {
    return (
      <div
        className="button back"
        onClick={() => {
          if (props.pathname === router.CONTACT) {
            history.push(router.FAQ);
          } else {
            history.push(router.QUESTION)
          }
        }}
      >
        <img src={back} alt="back"/>
      </div>
    );
  }
  
  function renderButtonCancel(): ReactNode {
    return (
      <div
        className="button cancel"
        onClick={() => history.push(router.QUESTION)}
      >
        <img src={cancel} alt="cancel"/>
      </div>
    );
  }
  
  return (
    <div id="misc-header">
      <div className="title-box">
        {renderButtonBack()}
        {renderTitle()}
        {
          props.pathname === router.CONTACT &&
          renderButtonCancel()
        }
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {},
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    pathname: store.setPathname.pathname,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(MiscHeader);
